var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9985 29.0015H14.7485L25.8085 17.9415L22.0585 14.1915L10.9985 25.2515V29.0015ZM12.9985 26.0815L22.0585 17.0215L22.9785 17.9415L13.9185 27.0015H12.9985V26.0815Z",
    fill: "#89A6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3685 11.2915C25.9785 10.9015 25.3485 10.9015 24.9585 11.2915L23.1285 13.1215L26.8785 16.8715L28.7085 15.0415C29.0985 14.6515 29.0985 14.0215 28.7085 13.6315L26.3685 11.2915Z",
    fill: "#89A6FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#546A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d09ff3cf1c27a1d33ac6b3c1d70992c1.svg";
export { ForwardRef as ReactComponent };